import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';

import { Constructionsite } from '../models/constructionsite'
import { ConstructionPhase } from '../models/construction-phase';
import { Cost } from '../models/cost'
import { HoursOption } from '../models/hours-option'
import { KindOfWork } from '../models/kind-of-work'
import { Tool } from '../models/tool'
import { WorkerCost } from '../models/worker-cost'
import { Worker } from '../models/worker'
import { Message } from '../models/message';
import { Registration } from '../models/registration';
import { DailyClockStatus } from '../models/daily-clock-status';
import { Permission } from '../models/permission';
import { Justification } from '../models/justification';
import { JustificationReason } from '../models/justification-reason';
import { JustificationNote } from '../models/justification-note';
import { environment } from '../../../environments/environment';
import DataSource from 'devextreme/data/data_source';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { Clock } from '../models/clock';
import { ClockMarker } from '../models/clock-marker';
import { ClockRegistrationElaborationDetail } from '../models/clock-registration-elaboration';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';
import { Controls } from '../models/controls';
import { WorkerCosts } from '../models/worker-costs';
import { Material } from '../models/material';
import { WorkerDailyHours } from '../models/worker-daily-hours';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  private apiUrl;
  private tenantID: number;

  constructor(private http: HttpClient)
  {
    
    this.apiUrl = environment.ApiUrl + '/';
    this.tenantID = this.readTenantId();
  }

  readTenantId(): number {
    let tenant = localStorage.getItem("tenantId");
    tenant ??= "0";
    return +tenant;
  }

  getOptions(): Observable<HoursOption> {
    this.tenantID = this.readTenantId();
    return this.http.get<HoursOption>(this.apiUrl + 'Options/Tenant/' + this.tenantID);
  }

  getConstructionSites(): Observable<Constructionsite[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<Constructionsite[]>(this.apiUrl + 'ConstructionSites?tenantId=' + this.tenantID);
  }

  getConstructionPhases(): Observable<ConstructionPhase[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<ConstructionPhase[]>(this.apiUrl + 'ConstructionSites/ConstructionPhases?tenantId=' + this.tenantID);
  }

  getNearestContructionSiteCode(latitude: number, longitude: number): Observable<string>{
    this.tenantID = this.readTenantId();

    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    const result = this.http.get<string>(this.apiUrl + 'ConstructionSites/NearWorkerToday?tenantId=' + this.tenantID + '&workerNumber=' + workerNumber + '&latitudine=' + latitude + '&longitudine=' + longitude);

    return result;


    // old version
    // return this.http.get<string>(this.apiUrl + 'ConstructionSites/Nearest?tenantId=' + this.tenantID + '&latitudine=' + latitude + '&longitudine=' + longitude);
    
  }


  getControls(): Observable<Controls[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<Controls[]>(this.apiUrl + `controls?tenantId=` + this.tenantID);
  }


  getConstructionSitesDataSorce(): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'constructionSiteCode',
        loadUrl: this.apiUrl + 'ConstructionSites/Lookup?tenantId=' + tenantId,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      }),
      key: 'constructionSiteCode',      
      paginate: true,
      pageSize: 10
    });
  }

  getConstructionSitesStore(): CustomStore {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    const token = localStorage.getItem("jwt");

    return AspNetData.createStore({
        key: 'constructionSiteCode',
        loadUrl: this.apiUrl + 'ConstructionSites/Lookup?tenantId=' + tenantId,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      });
  }

  getConstructionPhasesDataSorce(cantierePadre?: string): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    let filtroPadre = ""
    let action = "PhaseLookup";

    if (cantierePadre) {
      filtroPadre = "&cantierePadre=" + cantierePadre;
      action = "GetPhaseFiltered";
    }

    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'constructionSiteCode',
        loadUrl: this.apiUrl + 'ConstructionSites/' + action + '?tenantId=' + tenantId + filtroPadre,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      }),
      paginate: true,
      pageSize: 10,
    });
  }

  getCosts(): Observable<Cost[]> {
    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    return this.http.get<Cost[]>(this.apiUrl + 'costs?tenantId=' + this.tenantID + '&workerNumber=' + workerNumber);
  }


  getCostsGeneral(): Observable<Cost[]> {
    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    return this.http.get<Cost[]>(this.apiUrl + 'costs/General?tenantId=' + this.tenantID);
  }


  getWorkerCosts(): Observable<WorkerCost[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<WorkerCost[]>(this.apiUrl + 'workers_costs?tenantId=' + this.tenantID);
  }

  getWorkerCostsAll(): Observable<WorkerCosts[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<WorkerCosts[]>(this.apiUrl + 'Costs/All?tenantId=' + this.tenantID);
  }

  getMessages(lastMessageId: number): Observable<Message[]> {
    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);
    return this.http.get<Message[]>(this.apiUrl + 'messages?tenantId=' + this.tenantID + '&lastReceivedMessage=' + lastMessageId + '&workerNumber=' + workerNumber);
  }

  markReadedMessages(message: Message): Observable<unknown> {
    return this.http.put(this.apiUrl + 'messages/readed/' + message.messageId, message);
  }

  getTools(): Observable<Tool[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<Tool[]>(this.apiUrl + 'tools?tenantId=' + this.tenantID);
  }

  getMaterials(): Observable<Material[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<Material[]>(this.apiUrl + 'material?tenantId=' + this.tenantID);
  }

  getMaterialsDataSorce(): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    let user = localStorage.getItem("user");
    user ??= "   ";
   
    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'materialCode',
        loadUrl: this.apiUrl + 'material/Lookup?tenantId=' + tenantId,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      }),
      key: 'materialCode',
      paginate: true,
      pageSize: 10
    });
  }

  getMaterialsStore(): CustomStore {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    const token = localStorage.getItem("jwt");

    return AspNetData.createStore({
      key: 'materialCode',
      loadUrl: this.apiUrl + 'material/Lookup?tenantId=' + tenantId,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          Authorization: "Bearer " + token
        }
      }
    });
  }

  getKindOfWorks(): Observable<KindOfWork[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<KindOfWork[]>(this.apiUrl + 'KindOfWorks?tenantId=' + this.tenantID);
  }

  getWorkers(): Observable<Worker[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<Worker[]>(this.apiUrl + 'workers?tenantId=' + this.tenantID);
  }

  getCurrentWorker(): Observable<Worker> {
    this.tenantID = this.readTenantId();

    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3).trim();

    return this.http.get<Worker>(this.apiUrl + 'workers/' + this.tenantID + '/' + workerNumber);
  }

  getWorkersDataSorce(): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";
    
    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'workerNumber',
        loadUrl: this.apiUrl + 'Workers/Lookup?tenantId=' + tenantId,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      }),
      paginate: true,
      pageSize: 10,
    });
  }

  getWorkerDailyHours(): Observable<WorkerDailyHours[]> {
    this.tenantID = this.readTenantId();
    return this.http.get<WorkerDailyHours[]>(this.apiUrl + 'Registrations/WorkerDailyHours?tenantId=' + this.tenantID);
  }

  getRegistrations(inizio: string, fine: string): Observable<Registration[]> {
    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    return this.http.get<Registration[]>(this.apiUrl + 'registrations?tenantId=' + this.tenantID + '&registrationUser=' + workerNumber + '&startDate=' + inizio + '&endDate=' + fine);
  }

  postRegistration(reg: Registration): Observable<unknown> {
    const controls = reg.controlsRegistration;
    return this.http.post(this.apiUrl + 'registrations', reg);
  }

  getClockDataSorce(): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);
    const today = new Date();
    const minDate = new Date(today.getTime() - (1000 * 60 * 60 * 24 * 2));

    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'clockId',
        loadUrl: this.apiUrl + 'clocks?tenantId=' + tenantId,
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              Authorization: "Bearer " + token
          }
        }
      }),
      sort: { selector: 'deviceDate', desc: true },
      paginate: true,
      pageSize: 10,
      filter: [['workerNumber', '=', workerNumber], 'and', ['deviceDate', '>', minDate]],

    });
  }
  
  getClockAdminDataSorce(): DataSource {
    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    const token = localStorage.getItem("jwt");

    return new DataSource({
      store: AspNetData.createStore({
        key: 'clockId',
        loadUrl: this.apiUrl + 'clocks?tenantId=' + tenantId,
        deleteUrl: this.apiUrl + 'clocks/Delete',
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: "Bearer " + token
          }
        }
      }),
      sort: 'deviceDate',
      paginate: true,
      pageSize: 50,

    });
  }

  getClock(clockId: number): Observable<Clock> {
    return this.http.get<Clock>(this.apiUrl + 'clocks/'+ clockId);
  }

  canModifyClock(clockId: number): Observable<boolean> {
    return this.http.get<boolean>(this.apiUrl + 'clocks/canModifyClock/' + clockId);
  }

  putClock(clk: Clock): Observable<unknown> {
    return this.http.put(this.apiUrl + 'clocks/' + clk.clockId, clk);
  }

  postClock(clk: Clock): Observable<unknown> {
    return this.http.post(this.apiUrl + 'clocks', clk);
  }

  deleteClock(clockId: number): Observable<unknown> {
    return this.http.delete(this.apiUrl + 'clocks?key=' + clockId);
  }

  getLastClockConstructionSiteCode(): Observable<string> {
    this.tenantID = this.readTenantId();

    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    return this.http.get<string>(this.apiUrl + 'Clocks/LastClockConstructionSiteCode/' + this.tenantID + '/' + workerNumber );
  }

  getClockMarkers(clockRegistrationId: number): Observable<ClockMarker[]> {
    return this.http.get<ClockMarker[]>(this.apiUrl + 'api/ClockElaborations/GetClockMarkers?clockRegistrationId=' + clockRegistrationId);
  }

  getClockRegistrationElaborationDetail(userRegistrationId: number): Observable<ClockRegistrationElaborationDetail> {
    return this.http.get<ClockRegistrationElaborationDetail>(this.apiUrl + 'api/ClockRegistrationElaborations/GetDetail?userRegistrationId=' + userRegistrationId);
  }

  putClockRegistrationElaborationDetail(detail: ClockRegistrationElaborationDetail): Observable<unknown> {
    let notes = detail.notes;
    if (notes == null) notes = ''
    return this.http.put(this.apiUrl + 'api/ClockRegistrationElaborations/PutNotes?registrationID=' + detail.userRegistrationID + '&notes=' + notes, detail);
  }
  putClockRegistrationElaborationDetailApprove(detail: ClockRegistrationElaborationDetail): Observable<unknown> {
    let notes = detail.notes;
    if (notes == null) notes = ''
    return this.http.put(this.apiUrl + 'api/ClockRegistrationElaborations/PutNotesAndApprove?registrationID=' + detail.userRegistrationID + '&notes=' + notes, detail);
  }
  //parte stagista Alessandro
  getDailyClocks(tenantId: number, workerNumber: string): Observable<DailyClockStatus[]> {
    return this.http.get<DailyClockStatus[]>(this.apiUrl + "api/CardClock/CheckDailyClocks/" + tenantId + "/" + workerNumber);
  }
  postJustificationNote(justificationNoteDto: any): Observable<JustificationNote> {
    return this.http.post<JustificationNote>(`${this.apiUrl}api/CardClock/InsertJustificationNote`, justificationNoteDto);
  }
  getJustifications(tenantId: number): Observable<Justification[]> {
    return this.http.get<Justification[]>(this.apiUrl + "api/CardClock/Justifications/" + tenantId);
  }
  getJustificationReason(tenantId: number): Observable<JustificationReason[]> {
    return this.http.get<JustificationReason[]>(this.apiUrl + "api/JustificationReason/GetJustificationReason/" + tenantId);
  }
  postPermission(permissionDto: any): Observable<Permission> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/InsertPermission`, permissionDto);
  }
  postLeave(leaveDto: any): Observable<Permission> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/InsertLeave`, leaveDto);
  }

  postLeaveValidationStart(leaveDto: any): Observable<Permission> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/InsertLeaveValidationStart`, leaveDto);
  }

  postLeaveValidationEnd(leaveDto: any): Observable<Permission> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/InsertLeaveValidationEnd`, leaveDto);
  }

  getPermissions(tenantId: number, workerNumber: string): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.apiUrl + `api/Permission/Permissions/${tenantId}/${workerNumber}`);
  }

  getPermissionsByTenant(tenantId: number): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.apiUrl + `api/Permission/PermissionsByTenant/${tenantId}`);
  }

  getPermissionByID(permissionId: string): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.apiUrl + `api/Permission/Permissions/${permissionId}`)
  }

  aggiornaFerie(leaveDto: any): Observable<unknown> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/UpdateFerie`,leaveDto);
  }
  aggiornaPermessi(leaveDto: any): Observable<unknown> {
    return this.http.post<Permission>(`${this.apiUrl}api/Permission/UpdatePermessi`, leaveDto);
  }
  deletePermission(idPermission: any): Observable<unknown> {
    return this.http.delete<Permission>(`${this.apiUrl}api/Permission/DeletePermission/${idPermission}`);
  }

  aggiornaWorkerNotificationToken(notificationUserToken: string): Observable<unknown> {
    let user = localStorage.getItem("user");
    user ??= "   ";
    const workerNumber = user.substring(3);

    const url = `${this.apiUrl}workers/AggiornaNotificationToken/${this.tenantID}/${workerNumber}`;

    // invia un oggetto JSON: { notificationToken: "..." }
    return this.http.put(url, { notificationToken: notificationUserToken });

    //return this.http.put(`${this.apiUrl}workers/AggiornaNotificationToken/${this.tenantID}/${workerNumber}`, { notificationToken: notificationUserToken });
  }


  putSetCostForRegistration(registrationID: number, costCode: string): Observable<unknown> {
    const url = this.apiUrl + `api/ClockRegistrationElaborations/PutSetCostForRegistration/PutSetCostForRegistrations/${registrationID}/${costCode}`;

    return this.http.put(url, null); 
  }
}
